import React from 'react';
import styled from 'styled-components';
import Colors from '../../styles/colors';

const PoweredByStripe = (props) => {
  return (
    <PoweredBy>
      <div className="notice">
        <i className="ti-lock"/>
        Transactions are secure and encrypted.
      </div>
      <div className="logo">
        <img
          src="../../images/powered_by_stripe.png"
          alt="image"
        />
      </div>
    </PoweredBy>
  );
};

const PoweredBy = styled.div`
  display:flex;
  align-items: center;
  justify-content: space-between;

  .notice {
    display: flex;
    letter-spacing: 0.01em;
    font-size: 13px;
    color: #000;

    i {
      font-size: 16px;
      padding: 2px 5px 2px 0;
    }
  }

  .logo {
    background-color: ${Colors.mainOrange};
    overflow: hidden;
    width: 138px;
    height: 30px;
    margin-right: -8px;

    img {
      width: 100%;
      height: 100%;
    }
  }
`;

export default PoweredByStripe;
